/**
 * 能力类型分类占比组件
 */

import { useEffect, useState } from 'react';
import $ from 'jquery';
import { UjoinParams, AddRequestHeaders } from '../../incs/FunHelper.js';
import RTypePercent from '../../components/RTypePercent.js';
import CNF from '../../incs/Config.js';

const UserUDATC = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.orgInfosLists.length > 0 && isRefresh) {
            const params = {
                'org_info_ulid': props.orgInfosLists[0].key,
            }
            $.ajax({
                url: `${CNF.sealApi}reports/user/udatc${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET',
            }).done(function (data) {
                if (data.res === 0) {
                    setData(data.dat);
                }
            }).always(() => {
                setIsRefresh(false);
            });
        }
    }, [props]);

    return <RTypePercent id='antv-g2-id-UserUDATC' data={data} />
}

export default UserUDATC;